// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2-Ijz","imageUploader":"EGiftCard_imageUploader__2iFDR"};